import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, Calendar, Mail, Phone, Heart, ArrowRight } from 'lucide-react';

const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <main className="thank-you-page" data-testid="thank-you-page">
      <div className="thank-you-container">
        {/* Success Icon */}
        <div className="success-icon" data-testid="success-icon">
          <CheckCircle size={80} />
        </div>

        {/* Main Message */}
        <h1>Thank You for Your <span>Purchase!</span></h1>
        <p className="subtitle">
          Your payment has been processed successfully. Welcome to your recovery journey with Dr. Drea.
        </p>

        {orderNumber && (
          <div className="order-info" data-testid="order-info">
            <p>Order Reference: <strong>#{orderNumber}</strong></p>
          </div>
        )}

        {/* Next Steps Card */}
        <div className="next-steps-card" data-testid="next-steps-card">
          <h2><Heart size={24} /> What Happens Next?</h2>
          
          <div className="steps-list">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Check Your Email</h3>
                <p>You'll receive a confirmation email with your purchase details and receipt within a few minutes.</p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Schedule Your First Session</h3>
                <p>Click the button below to book your first coaching session at a time that works for you.</p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Prepare for Your Session</h3>
                <p>Find a quiet, private space where you feel comfortable. Come with an open mind and any questions you have.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Schedule CTA */}
        <div className="schedule-cta" data-testid="schedule-cta">
          <button 
            type="button"
            className="thankyou-schedule-btn"
            data-testid="schedule-session-btn"
            onClick={() => window.open('https://calendly.com/drea-drdreasobercoaching/free-consultation-w-dr-drea', '_blank')}
          >
            <Calendar size={20} />
            Schedule Your First Session
            <ArrowRight size={18} />
          </button>
        </div>

        {/* Contact Info */}
        <div className="contact-info-card" data-testid="contact-info">
          <h3>Questions? Reach Out Anytime</h3>
          <div className="contact-methods">
            <a href="mailto:drea@drdreasobercoaching.com" className="contact-method">
              <Mail size={18} />
              drea@drdreasobercoaching.com
            </a>
            <a href="tel:+1234567890" className="contact-method">
              <Phone size={18} />
              Schedule a Call
            </a>
          </div>
        </div>

        {/* Back to Home */}
        <div className="back-home">
          <Link to="/" className="back-link" data-testid="back-home-link">
            ← Back to Home
          </Link>
        </div>

        {/* Inspirational Quote */}
        <div className="quote-section" data-testid="quote-section">
          <blockquote>
            "The journey of a thousand miles begins with a single step. You've just taken yours."
          </blockquote>
          <p className="quote-author">— Dr. Drea</p>
        </div>
      </div>
    </main>
  );
};

export default ThankYouPage;
